import React, { useState } from 'react';
import './paymentSummary.scss';
import { useContent, useLanguages } from '../../../hooks/content';
import PaymentBoxB2B from '../PaymentBox/PaymentBoxB2B';

const PaymentSummaryB2B = ({
  selectedOrders,
  totalValue,
  nextClick,
  setActiveOrder,
  activeOrder,
  address,
  cancelClick,
  useraddress,
}) => {
  return (
    <div className="payment-summary">
      {/* <div className="details">
        <div className="title">
          {Returntext(contentManagementData, "PBT", lang)}
        </div>
        {selectedOrders.map((order, i) => (
          <OrderPriceDetails order={order} key={i} />
        ))}
      </div> */}

      <PaymentBoxB2B
        totalValue={totalValue}
        selectedOrders={selectedOrders}
        nextClick={nextClick}
        setActiveOrder={setActiveOrder}
        activeOrder={activeOrder}
        address={address}
        cancelClick={cancelClick}
        useraddress={useraddress}
      />
    </div>
  );
};

export default PaymentSummaryB2B;
